import {
  Container,
  createTheme,
  CssBaseline,
  ThemeProvider,
} from "@mui/material";
import React from "react";

const theme = createTheme({
  typography: {
    fontFamily: "GeneralSans-Variable",
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        @font-face {
          font-family: 'GeneralSans-Variable';
          font-style: normal;
          font-weight: 400;
          letter-spacing: 0.01em;
        }
      `,
    },
  },
});

export const NoAuthLayout = ({ children }: any): React.ReactElement => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline enableColorScheme />
      <Container maxWidth={false} disableGutters>
        {children}
      </Container>
    </ThemeProvider>
  );
};
